/* eslint-disable camelcase */

import React from 'react';
import { func, string } from 'prop-types';
import { connect } from 'react-redux';
import { formValueSelector, SubmissionError } from 'redux-form';
import axios from 'axios';

import headersForAjaxJson from 'utils/headersForAjaxJson';
import DuplicatePartnerForm from './DuplicatePartnerForm';
import {
  setPage as setPageAction,
  toggleModal as toggleModalAction
} from './redux/actions/uiActions';

export function DuplicatePartnerFormContainer({
  business_phone,
  primary_contact_email,
  setPage,
  toggleModal
}) {
  const handleSubmit = (values) =>
    axios
      .put(
        '/affiliate-contact/update_duplicate',
        { partner: values },
        { headers: headersForAjaxJson() }
      )
      .then(
        () =>
          setTimeout(() => {
            toggleModal();
            setPage(4);
          }, 100), // Waiting for Redux Form to finish its submit success actions
        (error) => {
          throw new SubmissionError(error.response.data.errors);
        }
      );

  const handleModalClose = () => toggleModal();

  return (
    <DuplicatePartnerForm
      initialValues={{ business_phone, primary_contact_email }}
      handleClose={handleModalClose}
      onSubmit={handleSubmit}
    />
  );
}

DuplicatePartnerFormContainer.propTypes = {
  business_phone: string,
  primary_contact_email: string,
  setPage: func.isRequired,
  toggleModal: func.isRequired
};

DuplicatePartnerFormContainer.defaultProps = {
  business_phone: undefined,
  primary_contact_email: undefined
};

const mapStateToProps = (state) =>
  formValueSelector('partnerSubmissionForm')(
    state,
    'business_phone',
    'primary_contact_email'
  );

export default connect(mapStateToProps, { setPageAction, toggleModalAction })(
  DuplicatePartnerFormContainer
);
